import { BasePackCard, type BasePackCardProps } from './BasePackCard'

export type RegularPackCardProps = Omit<BasePackCardProps, 'topBadge'>

export function RegularPackCard(props: RegularPackCardProps) {
  return <BasePackCard {...props} />
}
